import { useLocation } from 'react-router';

/**
 * Get the query parameters from the URL.
 */
export const useSearchParams = (): URLSearchParams =>
  new URLSearchParams(useLocation().search);
